module.exports = __webpack_public_path__ + "img/blank-bg.a61ab2d5.png";